/* tx-zones.js - snehove a vetrne oblasti pro obce CR (6255 obci), stav 10/2026.
   tx-zones-sk.js: hodnoty s_k z mapy CHMU / VSB-TUO (clima-maps.info/snehovamapa) pro stred kazde obce.
   tx-zones-sw.js: snehova oblast dle mapy CSN EN 1991-1-3 a vetrna oblast dle mapy CSN EN 1991-1-4 (obce serazene podle polohy).
   Snehova oblast = vyssi z (mapa CSN, oblast odpovidajici s_k CHMU). Mistu se priradi hodnoty nejblizsi obce. */
(function (w) {
  var me = document.currentScript && document.currentScript.src;
  function load(name) {
    if (!me) return;
    var s = document.createElement('script');
    s.src = me.replace('tx-zones.js', name);
    document.head.appendChild(s);
  }
  if (!w.TXZ_SK) load('tx-zones-sk.js');
  if (!w.TXZ_SN) load('tx-zones-sw.js');
  var P = null;
  function pts() {
    if (P) return P;
    var s = atob(w.TXZ_SK), SN = w.TXZ_SN, WI = w.TXZ_WI, n = s.length / 4, r = [];
    for (var i = 0; i < n; i++) {
      var o = i * 4, v = ((s.charCodeAt(o) << 24) >>> 0) + (s.charCodeAt(o + 1) << 16) + (s.charCodeAt(o + 2) << 8) + s.charCodeAt(o + 3);
      r.push([v >>> 20, (v >>> 8) & 4095, v & 255]);
    }
    r.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    var a = new Float32Array(n * 5);
    for (var j = 0; j < n; j++) {
      a[j * 5] = 48.5 + r[j][0] * 0.002;
      a[j * 5 + 1] = 12 + r[j][1] * 0.002;
      a[j * 5 + 2] = SN.charCodeAt(j) - 49;
      a[j * 5 + 3] = WI.charCodeAt(j) - 49;
      a[j * 5 + 4] = r[j][2] / 20;
    }
    return (P = a);
  }
  var ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];
  var SNOW = ['0,7', '1,0', '1,5', '2,0', '2,5', '3,0', '4,0', 'nad 4,0'];
  var WIND = ['22,5', '25', '27,5', '30', '36'];
  var TH = [0.7, 1.0, 1.5, 2.0, 2.5, 3.0, 4.0];
  function zoneOf(sk) {
    for (var i = 0; i < TH.length; i++) if (sk <= TH[i] + 0.001) return i;
    return 7;
  }
  function ready() { return !!(w.TXZ_SK && w.TXZ_SN && w.TXZ_WI); }
  function lookup(lat, lng) {
    var a = pts(), k = Math.cos(lat * Math.PI / 180), best = -1, bd = 1e9;
    for (var i = 0; i < a.length; i += 5) {
      var dy = a[i] - lat, dx = (a[i + 1] - lng) * k, d = dy * dy + dx * dx;
      if (d < bd) { bd = d; best = i; }
    }
    var km = Math.sqrt(bd) * 111.2;
    if (best < 0 || km > 8) return null;
    var nz = a[best + 2], wz = a[best + 3], sk = a[best + 4], cz = zoneOf(sk), z = Math.max(nz, cz);
    return {
      snow: z, snowRoman: ROMAN[z], snowLoad: SNOW[z],
      snowNorm: nz, snowNormRoman: ROMAN[nz],
      sk: sk, skText: sk.toFixed(2).replace('.', ','), skZone: cz,
      wind: wz, windRoman: ROMAN[wz], windSpeed: WIND[wz],
      km: km,
      chmu: 'https://clima-maps.info/snehovamapa/'
    };
  }
  var api = { lookup: lookup, ROMAN: ROMAN, SNOW: SNOW, WIND: WIND };
  (function wait() { if (ready()) w.TXZones = api; else setTimeout(wait, 100); })();
})(window);
